module.exports = {
    SPWS_UNLOCK_INFOS: [
        {
            // Ctrl + Alt + P
            special_key: 1,
            info: [{
                immutable_id: [601],
                special_requirement_id: ["ES6"],
                abbreviation_id: "ES"
            }]
        },
        {
            // Ctrl + Alt + U
            special_key: 2,
            info: [{
                immutable_id: [101],
                special_requirement_id: ["MCAM1"],
                abbreviation_id: "MC"
            }, {
                immutable_id: [201, 301, 401, 501, 502, 503],
                special_requirement_id: ["ES2", "ES3", "ES4", "ES5"],
                abbreviation_id: "ES"
            }, {
                immutable_id: [501, 502, 503],
                special_requirement_id: ["ES5"],
                abbreviation_id: "ADAS"
            }]
        },
        {
            // Ctrl + Alt + D
            special_key: 3,
            info: [{
                immutable_id: [101],
                special_requirement_id: ["ES1"],
                abbreviation_id: "ES"
            }]
        },
        {
            // Ctrl + Alt + M
            special_key: 4,
            info: [{
                immutable_id: [201],
                special_requirement_id: ["MVS2"],
                abbreviation_id: "FSC"
            }]
        }
    ]
};
